import React, { useEffect, useState } from 'react'
import { store } from '../../../redux/store';
import { Button, Input, Modal, Table, ConfigProvider, notification, Radio } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import zhCN from 'antd/es/locale/zh_CN';
import Serach from '../../generalComponent/search';
import { useNavigate } from 'react-router-dom';
//引入axios 进行服务器接口请求
import axios from "axios";
export default function Container() {
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, title, msg) => {
    api[type]({
      message: title,
      description: msg,
      placement: 'top',
      duration: 1
    });
  };

  const initialFields = { 'packName': '', 'packUnit': '' };
  const initState = { 'id': '', 'packName': '', 'packUnit': 1, 'packWeight': '', 'packPrice': '', 'status': 1, 'packName_isVisible': false, 'packPrice_isVisible': false, 'packWeight_isVisible': false };
  const [state, setState] = useState(initState);
  const [dataSource, setDataSource] = useState([]);
  const [query, setQuery] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [modalTitle, setModalTitle] = useState("");

  useEffect(() => {
    queryList({});
  }, []); // 空数组确保只在挂载时设置观察者

  let navigate = useNavigate();

  const token = store.getState().uData.token;
  function queryList(data) {
    //请求后台接口
    // / 设置全局的Authorization头
    axios.defaults.headers.common['token'] = token;
    axios.post('/api/pack/list',
      data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    ).then(
      response => {
        if (response.data.code === "200") {
          setDataSource(response.data.data);
          setSelectedRowKeys([])
        } else {
          setDataSource({});
          setSelectedRowKeys([])
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  };

  const [open, setOpen] = useState(false);

  //查询数据详情
  function modifyShowModal(id) {
    const params = new URLSearchParams();
    params.append('id', id);
    axios.defaults.headers.common['token'] = token;
    axios.post('/api/pack/find',
      params
    ).then(
      response => {
        if (response.data.code === "200") {
          setState(response.data.data);
          setModalTitle("编辑包装信息")
          setOpen(true);
        } else {
          openNotificationWithIcon('error', '消息提示', '数据查询失败！')
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  const showModal = () => {
    setState(initState);
    setModalTitle("新增包装信息")
    setOpen(true);
  };
  const handleOk = () => {
    handleAddOrModify();
  };
  const handleCancel = () => {
    setOpen(false);
  };

  //启用
  function handleBatchOpenAndClose(type) {
    const checkIds = selectedRowKeys;
    if (checkIds.length===0) {
      openNotificationWithIcon('warning', '消息提示', '请先选择要启停的数据!')
      return;
    }
    const params = new URLSearchParams();
    params.append('ids', checkIds.join(","));
    //请求后台接口
    const url=type===1?'/api/pack/open':'/api/pack/close';
    const success_msg=type===1?'数据启用成功！':'数据停用成功！';
    const error_msg=type===1?'数据启用失败！':'数据停用失败！';
    axios.defaults.headers.common['token'] = token;
    axios.post(url,
      params
    ).then(
      response => {
        if (response.data.code === "200") {
          const newSelectedRowKeys = [];
          for (let i = 0; i < selectedRowKeys.length; i++) {
            if (!checkIds.includes(selectedRowKeys[i])) {
              newSelectedRowKeys.push(selectedRowKeys[i]);
            }
          }
          setSelectedRowKeys(newSelectedRowKeys);
          queryList(query);
          openNotificationWithIcon('success', '消息提示', success_msg)
        } else {
          openNotificationWithIcon('error', '消息提示', error_msg)
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  function handleOpenAndClose(id,type) {
    if (id === "") {
      openNotificationWithIcon('warning', '消息提示', '请先选择要启停的数据!')
      return;
    }
    const params = new URLSearchParams();
    params.append('ids', id);
    //请求后台接口
    const url=type===1?'/api/pack/open':'/api/pack/close';
    const success_msg=type===1?'数据启用成功！':'数据停用成功！';
    const error_msg=type===1?'数据启用失败！':'数据停用失败！';

    axios.defaults.headers.common['token'] = token;
    axios.post(url,
      params
    ).then(
      response => {
        if (response.data.code === "200") {
          queryList(query);
          openNotificationWithIcon('success', '消息提示', success_msg)
        } else {
          openNotificationWithIcon('error', '消息提示', error_msg)
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  //添加或者修改
  function handleAddOrModify() {
    let valiad = true;
    //校验
    const { packName, packWeight, packPrice, packUnit, id, status } = state;
    const items = [
      { name: 'packName', val: packName },
      { name: 'packWeight', val: packWeight },
      { name: 'packPrice', val: packPrice }
    ];
    let success_msg = "";
    let error_msg = "";
    if (id) {
      success_msg = "数据修改成功！";
      error_msg = "数据修改失败！";
    } else {
      success_msg = "数据新增成功！";
      error_msg = "数据新增失败！";
    }

    items.map(item => {
      if (!item.val) {
        valiad = false;
        return setState(prevState => ({ ...prevState, [item.name + '_isVisible']: true }));
      }
      return null;
    })
    if (valiad) {
      const data = {
        id,
        packName,
        packWeight,
        packPrice,
        packUnit,
        status
      }
      //请求后台接口
      axios.post('/api/pack/addOrModify',
        data, {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      ).then(
        response => {
          if (response.data.code === "200") {
            openNotificationWithIcon('success', '消息提示', success_msg)
            queryList(query);
            setOpen(false);
          } else {
            openNotificationWithIcon('error', '消息提示', error_msg + response.data.msg)
            setOpen(true);
          }

        },
        error => {
          navigate("/error");
        }
      )
    }else{
      setOpen(true);
    }
  }
  //组装Serach组件的查询字段
  const searchFields = [
    {
      fieldName: 'packName',
      fieldCnName: '名称',
      placeholder: '请输入包装名称'
    }, {
      fieldName: 'packUnit',
      fieldCnName: '单位',
      placeholder: '请选择包装单位',
      fieldType: 'select',
      optionData: [
        { value: 1, label: '市斤' },
        { value: 2, label: '千克' },
        ]
    }
  ]


  const handleSearch = (data) => {
    setQuery(data);
    queryList(data);
  };
  const inputChange = (event) => {
    if (!event.target.value) {
      setState({
        ...state,
        [event.target.name]: '',
        [event.target.name + '_isVisible']: true,
      })
    } else {
      setState({
        ...state,
        [event.target.name]: event.target.value,
        [event.target.name + '_isVisible']: false,
      })
    }
  }

  const columns = [
    {
      title: '包装名称',
      dataIndex: 'packName',
      key: 'packName',
      fixed: 'left',
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: '包装重量',
      dataIndex: 'packWeight',
      key: 'packWeight',
      fixed: 'left',
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: '包装单位',
      dataIndex: 'packUnit',
      key: 'packUnit',
      align: 'center',
      responsive: ['lg'],
      render: (_, record) => (
        <span>{record.packUnit===1?"市斤":"千克"}</span>
      )
    },
    {
      title: '包装价格(元)',
      dataIndex: 'packPrice',
      key: 'packPrice',
      align: 'center',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.packPrice - b.packPrice,
      responsive: ['lg'],
    },
    {
      title: '使用状态',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      responsive: ['lg'],
      render: (_, record) => (
        <span style={record.status===1?{color:'#68cf4f'}:{color:'#FF0000'}}>{record.status===1?"启用":"停用"}</span>
      )
    },
    {
      title: '操作',
      key: 'operation',
      align: 'center',
      responsive: ['lg'],
      render: (_, record) => (
        <div>
          <a onClick={() => modifyShowModal(record.id)} style={{ marginRight: '20px' }}>编辑</a>
          <a onClick={() => handleOpenAndClose(record.id,1)} style={record.status===1?{marginRight: '20px',pointerEvents:'none',opacity: '0.5',color:'#2F4F4F'}:{marginRight: '20px',color:'#68cf4f'}} >启用</a>
          <a onClick={() => handleOpenAndClose(record.id,2)} style={record.status===2?{marginRight: '20px',pointerEvents:'none',opacity: '0.5',color:'#2F4F4F'}:{marginRight: '20px',color:'#FF0000'}}>停用</a>
        </div>
      )
    },
  ];

  return (
    <React.Fragment>
      {contextHolder}
      <div className="item-location">
        当前所在位置 : 包装配置
      </div>

      <Serach fields={searchFields} initState={initialFields} onSearch={handleSearch} />

      <div className="data-div">
        <div className="bt_group">
          <Button onClick={showModal} className="bt_group_add"><PlusOutlined />新增</Button>
          <Button className="bt_group_batch_open"   onClick={()=>handleBatchOpenAndClose(1)}><DeleteOutlined />批量启用</Button>
          <Button className="bt_group_batch_close"  onClick={()=>handleBatchOpenAndClose(2)}><DeleteOutlined />批量停用</Button>
        </div>
        <ConfigProvider locale={zhCN}>
          <Table
            columns={columns}
            rowKey="id"
            dataSource={dataSource}
            rowSelection={rowSelection}
            bordered
            pagination={{ position: ['bottomCenter'], hideOnSinglePage:'true' }}
            scroll={{ x: 1500 }}
            sticky={{ offsetHeader: 0 }}
          />
        </ConfigProvider>
      </div>

      <Modal
        open={open}
        title={modalTitle}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
        centered={true}
        cancelText="取消"
        okText="确定"
        maskClosable={false}
      >
        <div>
          <div className="modal_field_style">
            <div className="modal_field_name_style">
              <span style={{ color: 'red' }}>*</span>
              <span>包装名称:</span>
            </div>
            <div style={{ width: '90%' }}><Input size="large" placeholder="请输入包装名称" name='packName' value={state.packName} onChange={inputChange} /></div>
          </div>
          <div className="modal_field_tip_style">
            <div style={{ width: '89%' }}><span className={state.packName_isVisible ? 'tip-msg-show' : 'tip-msg-hidden'}>请输入包装名称</span></div>
          </div>

          <div className="modal_field_style">
            <div className="modal_field_name_style">
              <span style={{ color: 'red' }}>*</span>
              <span>包装重量:</span>
            </div>
            <div style={{ width: '90%' }}><Input size="large" placeholder="请输入包装重量" name='packWeight' value={state.packWeight} onChange={inputChange} /></div>
          </div>
          <div className="modal_field_tip_style">
            <div style={{ width: '89%' }}><span className={state.packWeight_isVisible ? 'tip-msg-show' : 'tip-msg-hidden'}>请输入包装重量</span></div>
          </div>


          <div className="modal_field_style_2">
            <div className="modal_field_name_style">
              <span>包装单位:</span>
            </div>
            <div style={{ width: '90%' }}>
            <Radio.Group name="packUnit" value={state.packUnit} onChange={inputChange}
                options={[
                  { value: 1, label: '市斤' },
                  { value: 2, label: '千克' }
                ]}
              />
              </div>
          </div>

          <div className="modal_field_style">
            <div className="modal_field_name_style">
              <span style={{ color: 'red' }}>*</span>
              <span>包装价格(元):</span>
            </div>
            <div style={{ width: '90%' }}><Input size="large" placeholder="请输入包装价格" name='packPrice' value={state.packPrice} onChange={inputChange} /></div>
          </div>
          <div className="modal_field_tip_style">
            <div style={{ width: '89%' }}><span className={state.packPrice_isVisible ? 'tip-msg-show' : 'tip-msg-hidden'}>请输入包装价格</span></div>
          </div>

          <div className="modal_field_style_2">
            <div className="modal_field_name_style">
              <span>使用状态:</span>
            </div>
            <div style={{ width: '90%' }}>
              <Radio.Group name="status" value={state.status} onChange={inputChange}
                options={[
                  { value: 1, label: '启用' },
                  { value: 2, label: '停用' }
                ]}
              /></div>
          </div>


        </div>
      </Modal>
    </React.Fragment>

  )
}
